import React from 'react';
import Switch from 'react-switch';
import clsx from 'clsx';

import styles from './Switcher.module.scss';

const Switcher = ({ checked = false, disabled = false, name, onChange }) => {
	return (
		<Switch
			onChange={onChange}
			checked={checked}
			id={name}
			disabled={disabled}
			checkedIcon={false}
			uncheckedIcon={false}
			handleDiameter={24}
			width={44}
			height={28}
			className={clsx(styles.switcher, checked && styles.checked)}
		/>
	);
};

export default Switcher;